import { render, staticRenderFns } from "./ApplicantAssetDetail.vue?vue&type=template&id=2c2ce626&"
import script from "./ApplicantAssetDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantAssetDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports